module.exports = __webpack_public_path__ + "img/trip(12).6bcc62a5.webp";